import React, { createContext, useContext, useState } from "react";
import { EventoRequestProps, registrarEventoAsync } from "services/TrackingService";

type TrackingContextProps = {
    sendTracking: (value: EventoRequestProps) => void;
}

const TrackingContext = createContext<TrackingContextProps>({} as any);

export const TrackingProvider = ({ children }: { children: React.ReactNode }) => {
    const [trackCode, setTrackCode] = useState<string | undefined>(undefined);

    const obterTrackId = (value: string | undefined = undefined) => {
        value && setTrackCode(value);
        return value || trackCode;
    }

    const sendTracking = async ({ trackId: value, ...rest }: EventoRequestProps) => {
        const code = obterTrackId(value)

        return registrarEventoAsync({
            trackId: code ?? value,
            ...rest
        }).then(({ data }) => setTrackCode(data));
    };

    return (
        <TrackingContext.Provider value={{ sendTracking }}>
            {children}
        </TrackingContext.Provider>
    );
};

export const useTracking = () => useContext(TrackingContext)
